<script>
	
    import Canvas from "../components/Canvas.svelte";
    import Header404 from "../components/Header404.svelte";

</script>


<main>
	
	<Canvas/>	
	<Header404 />

</main>
